module.exports = __webpack_public_path__ + "static/media/ic-openMode-dark-off.e2668b29.svg";